import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import ReactDOM from "react-dom";
import Front from "./components/Front";
import "../sass/index.scss";

ReactDOM.render(
    <Front />,
  document.getElementById("front")
);